import { render, staticRenderFns } from "./ProducerModal.vue?vue&type=template&id=6126b89c&"
import script from "./ProducerModal.vue?vue&type=script&lang=js&"
export * from "./ProducerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports